export const yearsForms = ["лет", "год", "года"];
export const monthsForms = ["месяцев", "месяц", "месяца"];

export const getWordForm = (number: number, forms: string[]) => {
  if (number === 0) return "";

  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return forms[0]; // лет/месяцев
  }
  if (lastDigit === 1) {
    return forms[1]; // год/месяц
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return forms[2]; // года/месяца
  }
  return forms[0]; // лет/месяцев
};

export const monthsToYearsString = (months: number) => {
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  const yearsPart =
    years > 0 ? `${years} ${getWordForm(years, yearsForms)}` : "";
  const monthsPart =
    remainingMonths > 0
      ? `${remainingMonths} ${getWordForm(remainingMonths, monthsForms)}`
      : "";

  if (yearsPart && monthsPart) {
    return `${yearsPart} ${monthsPart}`;
  } else if (yearsPart) {
    return yearsPart;
  } else if (monthsPart) {
    return monthsPart;
  } else {
    return "0 месяцев";
  }
};
